// next-app/src/components/survey/person-info.tsx
'use client';

import { FormInput } from '@/components/form/form-input';
import { FormMaskedInput } from '@/components/form/form-masked-input';

interface PersonInfoProps {
  disabled?: boolean;
}

/**
 * Personal information form section for surveys.
 * Collects first name, last name, email, and phone.
 */
export function PersonInfo({ disabled }: PersonInfoProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Personal Information</h2>

      <div className="grid gap-4 sm:grid-cols-2">
        <FormInput
          name="first_name"
          label="First Name"
          placeholder="Enter your first name"
          disabled={disabled}
        />

        <FormInput
          name="last_name"
          label="Last Name"
          placeholder="Enter your last name"
          disabled={disabled}
        />
      </div>

      <FormInput
        name="email"
        label="Email Address"
        type="email"
        placeholder="your.email@example.com"
        disabled={disabled}
      />

      <FormMaskedInput
        name="phone"
        label="Phone Number"
        mask="(999) 999-9999"
        placeholder="(555) 555-5555"
        disabled={disabled}
      />
    </div>
  );
}
